<div class="container embedded-report">
  <button *ngIf="isBotFiltersApplied" class="clear-filter-btn" mat-raised-button color="accent" (click)="clearReportFilter()">Clear Filters</button>
  <div [id]="embedReportContainerId"></div>
</div>
